import { IconButton } from '@mui/material';
import { increaseNftView, updateNft } from 'APIs/HotAuctionApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { addLike, selectNft } from 'features/auth/nftSlice';
import useLongPress from 'hooks/onLongPress';
import NftData from 'interfaces/NftData.interface';
import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import './Video.css';
import VideoSidebar from './VideoSidebar';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
interface VideoProps {
  url: string;
  data: NftData;
  setCurrentIndex: SetStateAction<any>;
  currentIndex: number;
  scrollDown?: (amount: number) => void;
  autoScroll: boolean;
  setAutoScroll: SetStateAction<any>;
}

const Video: React.FC<VideoProps> = ({
  url,
  data,
  setCurrentIndex,
  currentIndex,
  scrollDown,
  autoScroll,
  setAutoScroll,
}) => {
  const [menuShow, setMenuShow] = useState<boolean>(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const nftState = useAppSelector(selectNft);
  const authState = useAppSelector(selectAuth);
  const [liked, setLiked] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [onStart, onEnd] = useLongPress(() => setMenuShow(!menuShow), 500);
  const broom = require('assets/broom.png');

  const toggleLike = async () => {
    try {
      if (nftState.nfts && authState.id) {
        if (liked) {
          setLiked(false);
        } else {
          setLiked(true);
        }
        dispatch(addLike({ id: authState.id, currentIndex }));
        await updateNft({
          id: nftState.nfts[currentIndex].id,
          likes: [authState.id],
        });
      }
    } catch (error) {
      console.log(error);
      setLiked(false);
    }
  };

  const swipeUp = async () => {
    if (nftState.nfts) {
      if (currentIndex < nftState.nfts.length - 1) {
        setCurrentIndex((prev: number) => prev + 1);
      } else {
        setCurrentIndex(0);
      }
      try {
        await increaseNftView(nftState.nfts[currentIndex].id);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    let options = {
      rootMargin: '0px',
      threshold: [0.25, 0.75],
    };

    let handlePlay = (entries: any, observer: any) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current.play();
        } else if (videoRef.current) {
          videoRef.current.pause();
        }
      });
    };

    let observer = new IntersectionObserver(handlePlay, options);
    if (videoRef.current) observer.observe(videoRef.current);
  }, []);

  const navigate = useNavigate();
  const handlers = useSwipeable({
    // onSwiped: (eventData) => console.log("User Swiped!", eventData),
    onSwipedLeft: eventData => {
      if (window.innerHeight > window.innerWidth) {
        if (document?.fullscreenElement) {
          document.exitFullscreen();
        }
        navigate(`/nftauction/${data.id}`);
      }
    },
    // preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    onSwipedUp: async event => swipeUp(),
    onSwipedDown: event => {
      if (nftState.nfts) {
        if (currentIndex > 0) {
          setCurrentIndex((prev: number) => prev - 1);
        } else {
          setCurrentIndex(nftState.nfts.length - 1);
        }
      }
    },
  });

  React.useEffect(() => {
    const videoElem = document.querySelector('.video');
    if (videoElem) {
      videoElem.addEventListener('contextmenu', event =>
        event.preventDefault()
      );
    }
  }, []);

  useEffect(() => {
    if (nftState.nfts) {
      window.history.replaceState(
        null,
        'Buku',
        `/explore/nft/${nftState.nfts[currentIndex].id}`
      );
    }
  }, [currentIndex, nftState.nfts]);

  return (
    <div className="main__video__cont" {...handlers}>
      <Grid
        style={{
          width: '70%',
          display: 'flex',
          position: 'absolute',
          zIndex: '1000',
          margin: '20px 15%',
          justifyContent: 'space-around',
        }}
      >
        <NormalButton
          onClick={() => {
            navigate(`/explore/nft`);
          }}
          sx={{
            width: '110px',
            height: '47px',
            backgroundColor: '#ccaf35',
          }}
        >
          Explore NFT
        </NormalButton>
        <NormalButton
          onClick={() => {
            navigate(`/explore/otr`);
          }}
          sx={{
            width: '110px',
            height: '47px',
          }}
        >
          Explore OTR
        </NormalButton>
      </Grid>
      <div className="video" onTouchStart={onStart} onTouchEnd={onEnd}>
        <IconButton
          sx={{
            position: 'fixed',
            top: 20,
            left: 20,
            zIndex: 99,
            color: 'white',
          }}
          onClick={() => navigate('/')}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        <video
          // onClick={toggleVideoPlay}
          contextMenu="return false;"
          className="video__player"
          poster={url}
          src={url}
          ref={videoRef}
          muted={true}
          playsInline
          controlsList="nodownload"
          onEnded={
            scrollDown ? () => scrollDown(currentIndex * 100) : undefined
          }
        ></video>
        <div onClick={() => setMenuShow(!menuShow)} className="broom">
          <img
            src={broom}
            alt={'img'}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        <VideoSidebar
          isLiked={liked}
          toggleLike={toggleLike}
          data={data}
          className={`${menuShow && 'active'}`}
          autoScroll={autoScroll}
          setAutoScroll={setAutoScroll}
        />
      </div>
      {/* <div className="video__details">
        <Grid container className="second-div-upper-column">
          <Grid item className="second-div-first-section">
            <div className="second-div-title-section">
              <label className="title">Rama's Sea </label>
              <div className="views-button">
                <PlayArrow /> <label className="views-button-text">12.6k</label>
              </div>
            </div>
            <div className="paragraph-div">
              #991 Sky Phenomena, the very first NFT Artifact from the
              Figurative Museum.
            </div>
            <div className="paragraph-div">
              Artifacts are items collected from different worlds. When an
              architect finds them, they are brought to be displayed in our
              museum.
            </div>
            <div className="music-div">
              <img src={musicIcon} alt="music-icon" className="music-icon" />{' '}
              Acoustic Nights - Lofi
            </div>
          </Grid>
          <Grid item className="second-div-second-section">
            <div className="second-div-button-section">
              <div className="grey-button">NFT</div>
              <div className="grey-button-large">VIEW NFT · 1h15 left</div>
            </div>
            <div className="second-div-info-div">
              <div className="owner-div">
                <div className="owner-first-div">owned by</div>{' '}
                <div className="user-div">
                  <div className="user-info-icon-div">
                    <div className="user-info">
                      <img src={UserImage} alt="usr" className="user-image" />
                      <label>@leahx1611</label>
                    </div>
                    <div className="user-icon-container">
                      <img
                        src={UserPlus}
                        alt="user-plus"
                        className="user-plus-icon"
                      />
                    </div>
                  </div>
                  <div className="user-info-icon-div">
                    <div className="user-info">
                      <img src={UserImage} alt="usr" className="user-image" />
                      <label>@johnsea</label>
                    </div>
                    <div className="user-icon-container">
                      <img
                        src={UserPlus}
                        alt="user-plus"
                        className="user-plus-icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Divider
                style={{ marginBottom: 10, backgroundColor: '#707070' }}
                variant="middle"
              />
              <div className="owner-div">
                <div className="owner-first-div">collector</div>{' '}
                <div className="user-div">
                  <div className="user-info-icon-div">
                    <div className="user-info">
                      <img src={UserImage} alt="usr" className="user-image" />
                      <label>@leahx1611</label>
                    </div>
                    <div className="user-icon-container">
                      <img
                        src={UserPlus}
                        alt="user-plus"
                        className="user-plus-icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div> */}
    </div>
    // <VideoFooter />
  );
};

export default Video;
